<template>
  <v-btn
    :loading="loading"
    :disabled="disabled"
    block
    large
    outlined
    color="primary"
    class="sso-login-btn"
    @click="handleClick">
    <v-icon left color="blue">mdi-microsoft</v-icon>
    <span>{{ displayName }}</span>
  </v-btn>
</template>

<script>
import appConfig from '@/../appConfig';
import { rememberReturnPath } from '@/utils/returnPath';

export default {
  name: 'SSOLoginButton',
  props: {
    companyId: {
      type: String,
      default: null,
    },
    displayName: {
      type: String,
      default: 'Login with Microsoft',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
      if (this.companyId) {
        this.initiateSSO();
      }
    },
    initiateSSO() {
      const ssoUrl = `${appConfig.API_URL}api/sso/login/${this.companyId}`;
      // The identity provider drops our ?redirect= (e.g. the AI-assistant consent page); keep it.
      rememberReturnPath(new URLSearchParams(window.location.search).get('redirect'));
      window.location.href = ssoUrl;
    },
  },
};
</script>

<style scoped>
.sso-login-btn {
  text-transform: none;
  font-weight: 500;
}
</style>
